// extracted by mini-css-extract-plugin
export default {"control":"Input_control__s1r4S","invalid":"Input_invalid__E8iZe"};